<template>
  <b-row class="mt-2">

    <SearchOpts
      v-model="filters.paciente"
      :searchService="pacientesService.searchPacientesByTermSelect"
      :placeholder="'Buscar por nombre o cedula el paciente...'"
      class="col-6"
    />

    <SearchOpts
      v-if="isJefeMedico"
      v-model="filters.doctor"
      :searchService="doctoresService.searchDoctoresByTermSelect"
      :placeholder="'Buscar por nombre del doctor...'"
      :minChars="3"
      class="col-6"
    />

    <v-select 
      v-model="filters.estado" 
      :options="estadosOpts"
      :reduce="option => option.value" 
      placeholder="Buscar por estado." 
      label="text"
      class="col-md-3 mt-1" 
    />

    <v-select 
      v-model="filters.tipo" 
      :options="tipoOpts"
      :reduce="option => option.value" 
      placeholder="Buscar por tipo." 
      label="text"
      class="col-md-3 mt-1" 
    />

  </b-row>
</template>

<script>
import vSelect from 'vue-select';
import { SearchOpts } from '@/shared/components';
import { doctoresService } from "@/shared/services";
import { pacientesService } from "@/views/admision/services";
import { establecimientosService } from "@/views/administracion/services";
import { estadosInterconsultas, tipoInterconsultas } from '../../helpers';
import { isJefeMedico } from '../../helpers/isJefeMedico';

export default {
  name: 'FormFilterInterconsultas',

  components:{
    vSelect,
    SearchOpts
  },

  created(){
    this.loadInitData();
  },

  data(){
    return{

      pacientesOpts: [],
      establecimientoOpts : [],
      tipoOpts: tipoInterconsultas,

      isJefeMedico: isJefeMedico(),

      filters:{
        paciente:null,
        doctor:null,
        estado:null,
        establecimiento:null,
        search:false,
        tipo:null
      },

      estadosOpts: estadosInterconsultas,
      pacientesService:pacientesService,
      doctoresService:doctoresService
    }
  },


  methods:{

    async loadInitData(){
      this.establecimientoOpts = await establecimientosService.getForSelect();
    },

  },


  watch:{
    filters:{

      deep: true,
      handler(newValue){
        this.$store.commit("setInterconstultasFilters", newValue);
      }
    }
  }
}
</script>
